import { createGlobalStyle } from 'styled-components';
import PretendardRegular from '../font/pretendard/Pretendard-Regular.woff';
import theme from './theme';
const PretendardBlack = '../font/pretendard/Pretendard-Black.woff';
const PretendardExtraBold = '../font/pretendard/Pretendard-black.woff';
const PretendardBold = '../font/pretendard/Pretendard-black.woff';
const PretendardSemiBold = '../font/pretendard/Pretendard-black.woff';
const PretendardMedium = '../font/pretendard/Pretendard-black.woff';
// const PretendardRegular = '../font/pretendard/Pretendard-Regular.woff';
const PretendardLight = '../font/pretendard/Pretendard-black.woff';
const PretendardExtraLight = '../font/pretendard/Pretendard-black.woff';
const PretendardThin = '../font/pretendard/Pretendard-black.woff';

export const GlobalStyle = createGlobalStyle`

    @font-face {
        font-family: 'Pretendard';
        font-weight: 900;
        font-display: swap;
        src: local(''), url(${PretendardBlack}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 800;
        font-display: swap;
        src: local(''), url(${PretendardExtraBold}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 700;
        font-display: swap;
        src: local(''), url(${PretendardBold}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 600;
        font-display: swap;
        src: local(''), url(${PretendardSemiBold}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 500;
        font-display: swap;
        src: local(''), url(${PretendardMedium}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 400;
        font-display: swap;
        src: local(''), url(${PretendardRegular}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 300;
        font-display: swap;
        src: local(''), url(${PretendardLight}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 200;
        font-display: swap;
        src: local(''), url(${PretendardExtraLight}) format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 100;
        font-display: swap;
        src: local(''), url(${PretendardThin}) format('woff');
    }

    select {
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        min-width: 6rem;
        height: 2.7rem;
        background: ${theme.color.white[100]};
        border-radius: 8px;
        border: 1.4px solid ${theme.color.black[10]};
        outline: 0 none;
        // font-size: 0.8rem;
        text-align: center;
    }
    select > option {
        border-radius: 0px;
        border: 1px solid ${theme.color.black[20]};
        background: ${theme.color.white[100]};
        outline: 0 none;
        padding: 18px 0px;
    }
`;
